export default __webpack_public_path__ + "static/media/3Dcroc.50ee7a6f.png";